import {CanActivateViaAuthGuard} from './../bz-authentication/bz-can-activate-auth';
import {Routes} from '@angular/router';
import {ConnectInterfacesComponent} from './connect-interfaces/connect-interfaces.component';
import {ConnectConnectorsComponent} from './connect-connectors/connect-connectors.component';
import {ConnectEcmComponent} from './connect-ecm/connect-ecm.component';
import {ExcelConnectorComponent} from './connect-excel/connect-excel.component';
import {menus} from '../core/models/constants';
import {ConnectFormsRecognizerComponent} from './connect-forms-recognizer/connect-forms-recognizer.component';
import {ConnectSapCpComponent} from './connect-sap-cp/connect-sap-cp.component';
import { ConnectProviderComponent } from './connect-provider/connect-provider.component';
import { ConnectTriggersComponent } from './connect-triggers/connect-triggers.component';

export const RoutesConnect: Routes = [
  {
    path: menus.Interfaces.path,
    data: {title: menus.Interfaces.title},
    component: ConnectInterfacesComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.Connectors.path,
    data: {title: menus.Connectors.title},
    component: ConnectConnectorsComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.Triggers.path,
    data: {title: menus.Triggers.title},
    component: ConnectTriggersComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.ECM.path,
    data: {title: menus.ECM.title},
    component: ConnectEcmComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.ExcelConnector.path,
    data: {title: menus.ExcelConnector.title},
    component: ExcelConnectorComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.SAPCPConnector.path,
    data: {title: menus.SAPCPConnector.title},
    component: ConnectSapCpComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.FormsRecognizer.path,
    data: {title: menus.FormsRecognizer.title},
    component: ConnectFormsRecognizerComponent,
    canActivate: [CanActivateViaAuthGuard]
  },
  {
    path: menus.Providers.path,
    data: {title: menus.Providers.title},
    component: ConnectProviderComponent,
    canActivate: [CanActivateViaAuthGuard]
  }

];
